<template>
<div class="electrovalenceConfiguration">
  <el-card class="box-card" shadow="never">
    <div class="wrap-page">
      <el-button type="primary" size="small" @click="openDialog('add', {})" style="margin-bottom: 20px;">新增</el-button>
      <el-table ref="dataPointTable" :data="tableData" border highlight-current-row height="70vh" style="width: 100%;">
        <el-table-column type="index" label="序号" width="100">
        </el-table-column>
        <el-table-column prop="priceName" label="电价名称">
        </el-table-column>
        <el-table-column prop="time" label="创建时间">
        </el-table-column>
        <el-table-column prop="note" label="备注">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="{ row }">
            <el-button class="btn" type="text" size="small" @click="openDialog('edit', row)">修改</el-button>
            <el-button class="btn" type="text" size="small" @click="deleteRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
  <Dialog ref="electrovalenceDialog" :title="dialogTitle + '电价组合'" dlgWidth="80%">
    <el-form ref="formPrice" :inline="true" :model="formPrice" style="margin: 10px;">
      <el-card shadow="never">
        <el-form-item label="电价名称:">
          <el-input v-model="formPrice.priceName"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="formPrice.note" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="clearAllData">清空全部</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addProjectPriceInfo(tablePriceData)">保存全部</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addOnePrice">新增一行</el-button>
        </el-form-item>
      </el-card>
    </el-form>
    <div style="margin: 10px;">
      <el-table :data="tablePriceData" border style="width: 100%;margin-top: 10px;">
        <el-table-column prop="type" label="电价类型">
          <template slot-scope="{ row }">
            <div>
              <el-select v-model="row.kind">
                <el-option v-for="item in kindOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="峰谷类型">
          <template slot-scope="{ row }">
            <div>
              <el-select v-model="row.type">
                <el-option v-for="item in peekptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="电价">
          <template slot-scope="{ row }">
            <div>
              <el-input v-model.number="row.price" type="Number"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="startmonth" label="开始月份">
          <template slot-scope="{ row }">
            <div>
              <el-select v-model="row.startmonth">
                <el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="endmonth" label="结束月份">
          <template slot-scope="{ row }">
            <div>
              <el-select v-model="row.endmonth">
                <el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="starttime" label="开始时间">
          <template slot-scope="{ row }">
            <div>
              <el-select v-model="row.starttime">
                <el-option v-for="(item, index) in 25" :key="index" :label="index + '点'" :value="index"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="endtime" label="结束时间">
          <template slot-scope="{ row }">
            <div>
              <el-select v-model="row.endtime">
                <el-option v-for="(item, index) in 25" :key="index" :label="index + '点'" :value="index"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <el-button class="btn" size="small" icon="el-icon-delete" @click="deleteProjectPrice(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </Dialog>
</div>
</template>

<script>
import Dialog from '@/components/dialog';
import PROJECTAPI from '@/api/project';
export default {
  data() {
    return {
      tableData: [],
      dialogTitle: '新增',
      formPrice: {
        priceName: '',
        note: ''
      },
      kindOptions: [{
        id: 0,
        name: '市电电价'
      }, {
        id: 1,
        name: '备电电价'
      }, {
        id: 2,
        name: '充电桩电价'
      }],
      peekptions: [{
        id: 0,
        name: '平值'
      }, {
        id: 1,
        name: '峰值'
      }, {
        id: 2,
        name: '谷值'
      }, {
        id: 3,
        name: '尖值'
      }],
      tablePriceData: [],
    };
  },
  components: {
    Dialog
  },
  created() {},
  mounted() {
    this.searchProjectPriceInfo()
  },
  watch: {},
  methods: {
    //获取电价接口
    searchProjectPriceInfo() {
      PROJECTAPI.searchProjectPriceInfo().then(res => {
        if (res.data.code) {
          this.tableData = res.data.data
        }
      })
    },
    openDialog(type, row) {
      if (type == "add") {
        this.dialogTitle = '新增';
        this.formPrice = {};
        this.tablePriceData = [];
      } else {
        this.dialogTitle = '修改';
        this.formPrice = row;
        this.searchProjectPrice(row.id);
      }
      this.$refs.electrovalenceDialog.open();
    },
    //查看电价列表
    searchProjectPrice(priceId) {
      let params = {
        priceId: priceId
      };
      PROJECTAPI.searchProjectPrice(params).then(res => {
        if (res.data.code == 200) {
          this.tablePriceData = res.data.data;
        }
      });
    },
    //清空所有数据
    clearAllData() {
      this.tablePriceData = [];
    },
    //项目列表-新增电价组合实体
    addProjectPriceInfo(tablePriceData) {
      let self = this;
      let params = this.formPrice;
      PROJECTAPI.addProjectPriceInfo(params).then(res => {
        if (res.data.code == 200) {
          if (res.data.data) {
            //生成的实体赋值为编辑状态
            self.formPrice.id = res.data.data.id;
          }
          tablePriceData = tablePriceData.map(item => {
            item.priceId = res.data.data.id;
            return item;
          });
          if (tablePriceData.length > 0) {
            PROJECTAPI.updateBatchProjectPrice(tablePriceData).then(data => {
              self.$message.success('操作成功');
              self.searchProjectPrice(res.data.data.id);
            });
          }
          self.getSwitchSearchCodes(24);
        }
      });
    },
    addOnePrice() {
      var obj = {};
      let has = false;
      let self = this;
      this.tablePriceData.forEach(item => {
        if (item.price == '' || item.price == undefined) {
          has = true;
        }
      });
      if (!has) {
        let index = self.tablePriceData.length + 1;
        obj.index = index;
        self.tablePriceData.push(obj);
      } else {
        this.$message.warning('请完善数据信息！');
      }
    },
    //删除电价列表数据
    deleteProjectPrice(row) {
      if (row.index) {
        this.tablePriceData.splice(row.index - 1, 1);
        return;
      }
      let params = {
        priceId: row.id
      };
      let self = this;
      this.$confirm('确定要执行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          PROJECTAPI.deleteProjectPrice(params).then(res => {
            self.searchProjectPrice(row.priceid);
          });
        })
        .catch(() => {});
    },
    deleteRow(row) {
      
    }
  }
};
</script>

<style lang="scss" scoped>
.electrovalenceConfiguration {
  .box-card {
    width: 100%;
    height: 100%;
    padding-bottom: 10px;
  }

  >>>.el-dialog--center .el-dialog__body {
    height: 60vh;
    overflow: auto;
  }

  >>>.el-form-item .el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/electrovalenceConfiguration/index.vue